// extracted by mini-css-extract-plugin
module.exports = {"player":"Player_player__18xVV","fadeIn":"Player_fadeIn__1dHDp"};